module.exports = __webpack_public_path__ + "public/img/yanwu.c166084b.jpeg";